import { render, staticRenderFns } from "./ShopStore.vue?vue&type=template&id=0b60304c&scoped=true"
import script from "./ShopStore.vue?vue&type=script&lang=js"
export * from "./ShopStore.vue?vue&type=script&lang=js"
import style0 from "./ShopStore.vue?vue&type=style&index=0&id=0b60304c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60304c",
  null
  
)

export default component.exports